import React, { useState, useRef } from 'react'
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver.js'

export function LazyImage({
    src,
    alt,
    className = "",
    width,
    height,
    placeholder = null
}) {
    const [isLoaded, setIsLoaded] = useState(false)
    const [isInView, setIsInView] = useState(true) // 👈 changed

    const imgRef = useRef()

    const [ref] = useIntersectionObserver({
        threshold: 0,
        rootMargin: '50px',
        onChange: (isIntersecting) => {
            if (isIntersecting) {
                setIsInView(true)
            }
        }
    })

    const handleLoad = () => {
        setIsLoaded(true)
    }

    return (
        <div ref={ref} className={`relative overflow-hidden ${className}`}>
            {!isLoaded && placeholder && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                    {placeholder}
                </div>
            )}

            {isInView && (
                <img
                    ref={imgRef}
                    src={src}
                    alt={alt}
                    width={width}
                    height={height}
                    onLoad={handleLoad}
                    className={`transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'
                        } ${className}`}
                    loading="lazy"
                />
            )}
        </div>
    )
}
